import { useTranslation } from "react-i18next";
import { LiteBox } from "../../../../../components/lite/LiteBox";
import useOrganizationStyles from "../../use-organization-styles";
import { Link, Typography } from "@material-ui/core";
import { InfoOutlined, OpenInNew } from "@material-ui/icons";
import { useHistory } from "react-router";
import { LyfeTooltip } from "@lyfegen-platform/react-common";

type Subdomain = {
	name: string;
	level: number;
	id: string;
	simulationCount: number;
	users: { id: string }[];
};
interface IDomainTableProps {
	domains: Subdomain[];
	handleUserClick: (event: React.SyntheticEvent, domainId: string) => void;
	handleSimulationClick: (event: React.SyntheticEvent, domainId: string) => void;
	domainColumnKey: string;
}

export const DomainTable = (props: IDomainTableProps) => {
	const {
		domainTableContainer,
		displayFlex,
		newTabLinkIcon,
		tableColumnTextColor,
		domainTable,
		cursorPointer,
		scrollableTableContainer,
		weight600,
	} = useOrganizationStyles();
	const { t } = useTranslation();
	const { push } = useHistory();

	const handleDomainClick = (event: React.SyntheticEvent, domainId: string) => {
		event.preventDefault();
		push(`/organization-settings/domains/${domainId}`);
	};

	return (
		<LiteBox mt={2} className={scrollableTableContainer}>
			<table className={domainTable}>
				<thead>
					<tr>
						<th style={{ paddingLeft: 16, width: "22%" }}>
							<Typography className={`${tableColumnTextColor} ${weight600}`} variant="subtitle2" align="left">
								{t(props.domainColumnKey)}
							</Typography>
						</th>
						<th style={{ width: "22%" }}>
							<Typography className={`${tableColumnTextColor} ${weight600}`} variant="subtitle2" align="left">
								{t("organization-settings-tab-users")}
							</Typography>
						</th>
						<th>
							<LiteBox display={"flex"} alignItems={"center"}>
								<Typography
									style={{ marginRight: 6 }}
									className={`${tableColumnTextColor} ${weight600}`}
									variant="subtitle2"
									align="left"
								>
									{t("domain-table-simulations")}
								</Typography>
								<LyfeTooltip title={t("domain-table-simulations-note")}>
									<InfoOutlined color="primary" fontSize="small" />
								</LyfeTooltip>
							</LiteBox>
						</th>
					</tr>
				</thead>
				<tbody className={domainTableContainer}>
					{props.domains.map((domain) => (
						<tr key={domain.id} style={{ marginTop: 2, marginBottom: 2 }}>
							<td style={{ paddingLeft: 16 }}>
								<Link
									className={`${displayFlex} ${cursorPointer}`}
									onClick={(event) => handleDomainClick(event, domain.id)}
									underline="none"
								>
									<Typography variant="subtitle2" color="primary">
										{domain.name}
									</Typography>
								</Link>
							</td>
							<td>
								{!!domain.users.length ? (
									<Link
										className={displayFlex}
										onClick={(event) => props.handleUserClick(event, domain.id)}
										underline="none"
									>
										<Typography variant="subtitle2" color="primary">
											{`${domain.users.length} ${t("organization-settings-tab-users").toLowerCase()}`}
										</Typography>
										<OpenInNew color="primary" className={newTabLinkIcon} />
									</Link>
								) : (
									<Typography variant="subtitle2" color="textPrimary">
										{`${domain.users.length} ${t("organization-settings-tab-users").toLowerCase()}`}
									</Typography>
								)}
							</td>
							<td>
								{!!domain.simulationCount ? (
									<Link
										className={displayFlex}
										onClick={(event) => props.handleSimulationClick(event, domain.id)}
										underline="none"
									>
										<Typography variant="subtitle2" color="primary">
											{`${domain.simulationCount} ${t("domain-table-simulations").toLowerCase()}`}
										</Typography>
										<OpenInNew color="primary" className={newTabLinkIcon} />
									</Link>
								) : (
									<Typography variant="subtitle2" color="textPrimary">
										{`${domain.simulationCount} ${t("domain-table-simulations").toLowerCase()}`}
									</Typography>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</LiteBox>
	);
};
